// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"7558":"ef9ce60eccfd16cf","9447":"a25dc80da666c941"}[chunkId] + ".css";
};